import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';
import { getUserProfileDetail,updateUserEmail,updateUserPassword } from "../../utils/admin/dashboardApi";

export default function AccountSettings() {
    const [profileData, setProfileData] = useState({user_id: "", email: "",});
    const [isLoading, setIsLoading] = useState(true);

    // States for Email Modal
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [newEmail, setNewEmail] = useState("");
    const [isUpdatingEmail, setIsUpdatingEmail] = useState(false);

    // States for Password Modal
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);

    // Fetch user profile data
    const fetchProfileData = async () => {
        setIsLoading(true);
        try {
            const result = await getUserProfileDetail();
            if (result && result.data) {
                setProfileData({
                    user_id: result.data.id || "",
                    email: result.data.email || "",
                });

                // Update session storage with new email
                sessionStorage.setItem("user_detail", JSON.stringify(result.data));
            }
        } catch (error) {
            //console.log(`${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProfileData();
    }, []);

    // Email Update Handler
    const handleEmailUpdate = async (e) => {
        e.preventDefault();
        if (!newEmail) {
            toast.error("Please enter a valid email.");
            return;
        }

        setIsUpdatingEmail(true);
        try {
            const response = await updateUserEmail({ email: newEmail });
            if (response.status) {
                toast.success(response.message);
                setProfileData({ email: newEmail });
                setIsEmailModalOpen(false);
                setNewEmail("");

                // Fetch Updated Profile Data
                fetchProfileData();
                // Wait for 3 seconds, then refresh the page
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsUpdatingEmail(false);
        }
    };

    // Password Update Handler
    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        if (!newPassword || newPassword.length < 6) {
            toast.error("Password must be at least 6 characters.");
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        }

        setIsUpdatingPassword(true);
        try {
            const response = await updateUserPassword({ new_password: newPassword });
            if (response.status) {
                toast.success(response.message);
                setIsPasswordModalOpen(false);
                setNewPassword("");
                setConfirmPassword("");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsUpdatingPassword(false);
        }
    };

    return (
        <>
        <div className="container-scroller admin-dashboard-page">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        <div className="admin-account-settings-page">
                        <div className="mt-4 px-4 pb-4 w-100 admin-account-settings-body">
                        <div className="my-profile-saction">
                            <div className="my-profile-saction-inner">
                                {isLoading ? (
                                    <div className="loader-container">
                                        <div className="spinner"></div>
                                        <p>Loading please wait...</p>
                                    </div>
                                ) : (
                                <>
                                    <h2>Account & Security</h2>
                                    <ul className='notifaction-list account-settings-list'>
                                        <li>
                                            <div className="list-li-left">
                                                <span className="span-1">Email</span>
                                                <i>{profileData.email}</i>
                                                <em>verified</em>
                                            </div>
                                            <div className="list-li-right">
                                                <button className="button-popup account-action-btn" onClick={() => setIsEmailModalOpen(true)}>Change Email</button>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="list-li-left">
                                                <span className="span-1">Password</span>
                                                <i>**********</i>
                                            </div>
                                            <div className="list-li-right">
                                            <button className="button-popup account-action-btn" onClick={() => setIsPasswordModalOpen(true)}>Change Password</button>
                                            </div>
                                        </li>
                                    </ul>
                                </>
                                )}
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Email Change Modal */}
            {isEmailModalOpen && (
                <div className="modal-overlay account-settings-modal-overlay">
                    <div className="modal-content account-settings-modal-content">
                        <div className="account-settings-modal-header">
                            <h2>Change Email</h2>
                            <button
                                className="account-settings-close-btn"
                                type="button"
                                onClick={() => setIsEmailModalOpen(false)}
                                aria-label="Close"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" />
                            </button>
                        </div>
                        <form onSubmit={handleEmailUpdate}>
                            <label>New Email</label>
                            <input type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} placeholder="Enter new email" required />
                            <div className="modal-buttons">
                                <button className="update-btn test" type="submit" disabled={isUpdatingEmail}>
                                    {isUpdatingEmail ? "Updating..." : "Update Email"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Password Change Modal */}
            {isPasswordModalOpen && ( 
                <div className="modal-overlay account-settings-modal-overlay">
                    <div className="modal-content account-settings-modal-content">
                        <div className="account-settings-modal-header">
                            <h2>Change Password</h2>
                            <button
                                className="account-settings-close-btn"
                                type="button"
                                onClick={() => setIsPasswordModalOpen(false)}
                                aria-label="Close"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" />
                            </button>
                        </div>
                        <form onSubmit={handlePasswordUpdate}>
                            <label>New Password</label>
                            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Enter new password" required />
                            <label>Confirm Password</label>
                            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm new password" required />
                            <div className="modal-buttons">
                                <button className="update-btn" type="submit" disabled={isUpdatingPassword}>
                                    {isUpdatingPassword ? "Updating..." : "Update Password"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
